import { VFlex, VModal, VSelect } from 'kiska';
import { useEffect, useState } from 'react';

import { useUserRoleMapper, useUserUpdateMutation } from '@/hook';
import type { User, UserRole } from '@/type';

type UserProfileChangeRoleModalProps = {
  selectedUser: User;
  visible: boolean;
  onUpdateVisible(visible: boolean): void;
  updateMyUserInfo?: (user: User) => void;
};

export const UserProfileChangeRoleModal = ({
  selectedUser,
  visible,
  onUpdateVisible,
  updateMyUserInfo,
}: UserProfileChangeRoleModalProps) => {
  const [newRole, setNewRole] = useState(selectedUser.role);
  const { mutate: updateUser } = useUserUpdateMutation();
  const { mapUserRole } = useUserRoleMapper();

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setNewRole(selectedUser.role);
  }, [selectedUser.role]);

  return (
    <VModal
      footer={{
        confirmText: 'OK',
        onConfirm: () => {
          if (!selectedUser || !newRole) return;
          updateUser(
            { ...selectedUser, role: newRole },
            {
              onSuccess: () => {
                updateMyUserInfo?.({ ...selectedUser, role: newRole });
              },
            },
          );
        },
      }}
      size="small"
      title={() => 'Change role'}
      visible={visible}
      onUpdateVisible={onUpdateVisible}
    >
      <VFlex justify="center" items="center">
        <VSelect
          itemList={[
            { value: 'Manager', label: mapUserRole('Manager') },
            { value: 'Worker', label: mapUserRole('Worker') },
            { value: 'SiteAdmin', label: mapUserRole('SiteAdmin') },
          ]}
          value={newRole}
          onChange={e => {
            setNewRole(e.target?.value as UserRole);
          }}
        />
      </VFlex>
    </VModal>
  );
};
